import axios from 'axios'
import { Message } from 'element-ui'
import { clearSession, getToken } from './auth/session'

let authFailureHandledAt = 0

const service = axios.create({
  baseURL: '/api',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' }
})

service.interceptors.request.use(config => {
  const token = getToken()
  if (token && !config.skipAuth) {
    config.headers.Authorization = `Bearer ${token}`
  }
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type']
  }
  return config
}, error => Promise.reject(error))

service.interceptors.response.use(response => {
  if (response.config.responseType === 'blob') {
    return response
  }
  const res = response.data
  if (res.code !== 200) {
    if ((res.code === 401 || res.code === 403) && !response.config.skipAuthRedirect) {
      handleAuthFailure(res.msg)
    } else {
      Message.error(res.msg || '请求异常')
    }
    const requestError = new Error(res.msg || '请求异常')
    requestError.code = res.code
    requestError.data = res.data
    return Promise.reject(requestError)
  }
  return res
}, error => {
  const statusMap = {
    401: '未授权，请重新登录',
    403: '拒绝访问',
    404: '请求资源不存在',
    500: '服务器错误'
  }
  const status = error.response && error.response.status
  const config = error.config || {}
  if ((status === 401 || status === 403) && !config.skipAuthRedirect) {
    handleAuthFailure(statusMap[status])
  } else {
    Message.error(statusMap[status] || '网络异常')
  }
  return Promise.reject(error)
})

function handleAuthFailure(message) {
  const now = Date.now()
  if (now - authFailureHandledAt < 1500) return
  authFailureHandledAt = now
  clearSession()
  Message.error(message || '登录状态已失效，请重新登录')
  if (window.location.pathname !== '/login') {
    window.location.replace(`/login?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`)
  }
}

export function request(options) {
  return service(options)
}

export const get = (url, params, options = {}) => request({ url, method: 'get', params, ...options })
export const post = (url, data, options = {}) => request({ url, method: 'post', data, ...options })
